import styled, { css } from "styled-components";

import {
  LibraryItem,
  Tags,
} from "routes/patients/PatientProfile/components/UserCourse/components/LibraryItem/LibraryItem";

import { PageContainer } from "./PageContainer";

export const headerFont = css`
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0.1px;
  margin: 0;
`;

export const defaultFont = css`
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.1px;
`;

export const CardContainer = styled.div`
  display: flex;
  justify-items: flex-start;
  flex-wrap: wrap;
  gap: 8px;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 16px;
  margin: auto;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 12px;

  ${props => props.theme.aboveBreakpoint} {
    padding: 40px;
  }
`;

export const PreviewContainer = styled.div<{ $boxShadow?: boolean }>`
  display: flex;
  flex-direction: column;
  padding: 8px;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 12px;
  border: ${({ theme, $boxShadow }) => ($boxShadow ? `1px solid ${theme.colors.redesign.db5}` : "none")};
  box-shadow: ${({ $boxShadow }) => ($boxShadow ? "0px 2px 4px 0px rgba(0, 0, 0, 0.05)" : "none")};

  ${props => props.theme.aboveBreakpoint} {
    padding: 24px;
  }
`;

export const StyledPageContainer = styled(PageContainer)`
  padding: 0 8px 8px;

  ${props => props.theme.aboveBreakpoint} {
    padding: 0;
  }
`;

export const TopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin: 40px 0 24px;
`;

export const Title = styled.h2`
  font-size: 22px;
  font-style: normal;
  font-weight: 600;
  letter-spacing: 0.1px;
  text-align: center;
  margin: 0;
  color: ${({ theme }) => theme.colors.black};
`;

export const SmallTitle = styled.div`
  font-size: 16px;
  font-weight: ${props => props.theme.fontWeight.bold};
  color: ${props => props.theme.colors.primary.base};
  margin: 16px 0 8px 0;
`;

export const StyledTags = styled(Tags)`
  margin: 0;
`;

export const FormPageInnerContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 40px;

  & .MuiFormControl-root {
    margin: 0;
  }

  ${({ theme }) => theme.aboveBreakpoint} {
    flex-direction: row;
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: fit-content;
  background-color: ${props => props.theme.colors.white};
  color: ${props => props.theme.colors.primary.base};
`;

export const FormPreviewContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 16px;
`;

export const StyledLibraryItem = styled(LibraryItem)`
  box-sizing: border-box;
  width: 100%;
  pointer-events: none;
  cursor: default;
`;
